import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { BodyText, CloudinaryImage, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemIngredient = (props: Props) => {
  const { imageAlt, imageUrl, name, shouldUseCompactGrid } = props;

  // ─── Styles ────────────────────────────────────────────────────────────────

  const containerStyles = shouldUseCompactGrid ? undefined : styles.container;

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles}>
      <CloudinaryImage
        baseUrl={imageUrl}
        config={IMAGE_CONFIG}
        contentFit="cover"
        style={styles.image}
        alt={imageAlt}
      />

      <View style={styles.nameContainer}>
        <BodyText sizeMatch={['14']} style={styles.name}>
          {name}
        </BodyText>
      </View>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_SIZE = 140;

const IMAGE_CONFIG: CloudinaryImageConfig = {
  width: IMAGE_SIZE,
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: IMAGE_SIZE,
  },
  image: {
    width: '100%',
    aspectRatio: 1,
    borderWidth: 1,
    borderColor: theme.colors.BROWN,
    borderRadius: theme.spacing['4'],
  },
  nameContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: theme.spacing['6'],
    paddingHorizontal: theme.spacing['1'],
  },
  name: {
    color: theme.colors.BROWN,
    textAlign: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  imageAlt: string;
  imageUrl: string;
  name: string;
  shouldUseCompactGrid: boolean;
};

type CloudinaryImageConfig = ComponentProps<typeof CloudinaryImage>['config'];
